import { Middleware } from '@reduxjs/toolkit';
import { MessageType } from '../actions/common';

export const pageVisibilityMiddleware: Middleware =
  (store) => (next) => (action) => {
    if (action.type === MessageType.STEERING_OPERATE) {
      if (document.hidden) {
        return;
      }
    }
    return next(action);
  };
